import * as React from 'react';

const TabsContext = React.createContext({
    activeTab: '',
    setActiveTab: () => { },
});

export { TabsContext };
